import { render, staticRenderFns } from "./WorkDetail5.vue?vue&type=template&id=1d433086&scoped=true&"
import script from "./WorkDetail5.vue?vue&type=script&lang=js&"
export * from "./WorkDetail5.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail5.vue?vue&type=style&index=0&id=1d433086&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d433086",
  null
  
)

export default component.exports